import { useState, useRef, useEffect } from "react";
import DynamicFormFieldId from "./DynamicFormFieldId";
import { CREATE_PAGE_INDEX } from "@src/config/id/constant";
import SingleUploadBox from "@common/SingleUploadBox";
import { ValidateFileInput } from "@src/config/helper";
import { isMobile } from "react-device-detect";
import Accordion from "react-bootstrap/Accordion";
import { DOC_IDS } from "@src/config/constant";
import { useDispatch } from "react-redux";
import { fetchPermanentLocality } from "./functions/common.fn";


// Handles document upload UI + dynamic form for a single document block
const DocumentSection = ({ document, index, sectionItem, setSectionItem, setLoading, requestData,isEdit, setDeletedDocs, uploadDocumentNow,setRequestData }: any) => {
  const fields = document?.fields || [];
  const files = sectionItem?.[index]?.uploaded_files || [];
  const [selectedChild, setSelectedChild] = useState<any>(null);
  const dispatch: any = useDispatch();
  
  // Special case: document has radio options (Existing Policy / Vehicle Photos)
  const isPolicyVehicleDoc = document?.label === "Existing Policy or Vehicle Photos" && document?.child?.length;

  const hasFilesInChild = (childNode: any): boolean => {
    if (childNode.uploaded_files?.length) return true;
    if (childNode.child?.length) {
      return childNode.child.some((c: any) => hasFilesInChild(c));
    }
    return false;
  };


useEffect(() => {
  if (!isPolicyVehicleDoc) return;

  const parent = sectionItem?.[index];
  if (!parent) return;

  const isPolicySelected = document?.child?.find((c: any) => c.value == DOC_IDS.EXITING_POLICY)?.uploaded_files?.length > 0;
  const defultSelectedValue =  isPolicySelected ? parent.child?.[0]?.value: parent.child?.[1]?.value;

  const selectedValue =
    parent.selected_policy_vehicle || (isEdit ? defultSelectedValue : parent.child?.[0]?.value)

  const matched = parent.child.find(
    (c: any) => c.value === selectedValue
  );

  setSelectedChild(matched);
}, [sectionItem]);



  // Add file to uploaded_files array
  const handleFileUpload = async (input?: any, childKey?: string) => {
    const fileList = input?.target?.files || (input ? [input] : null);
    if (!fileList?.length) return;

    try {
      const validateFile = await ValidateFileInput(fileList);
      if(validateFile) return;

      const file = fileList[0];
      const resolvedDocId = childKey || document?.ocr_doc_id ||document?.value ;
      const uploadedFile = uploadDocumentNow ? await uploadDocumentNow(file, resolvedDocId) : file;
      const updated = structuredClone(sectionItem);
      const currentSection = updated[index];
      
      // for auto filled the value
      const prefillFields = uploadedFile?.prefill_fields;

      if (prefillFields && Object.keys(prefillFields).length) {
        // for auto list district list
        for (const prefix of ["per", "cur"]) {
          const cityId = prefillFields?.[`${prefix}_city`];

          if (!cityId) continue;

          const localityRes: any = await fetchPermanentLocality({
            cityId: typeof cityId === "object" ? cityId?.value : cityId,
            prefix,
            dispatch,
          });

          if (!localityRes?.districtOptions?.length) continue;

          for (const field of currentSection?.fields || []) {
            if (field?.name === `${prefix}_district`) {
              field.options = localityRes.districtOptions;
              field.dynamicOptions = localityRes.districtOptions;
            }
          }
        }

        for (const field of currentSection?.fields || []) {
          if (Array.isArray(prefillFields[field?.name]) && field?.name?.endsWith("_district")) {
            continue;
          }
          if (Object.prototype.hasOwnProperty.call(prefillFields, field?.name)) {
            field.value = prefillFields[field.name] ?? "";
            field.error_message = '';
            field.error_msg = '';
          }
        }
      }

      if (childKey) {
        const parent = updated[index];
        const targetChild = findChildByValue(parent, childKey);
        
        const prev = targetChild.uploaded_files || [];
        targetChild.uploaded_files = [...prev, uploadedFile];
      } else {
        const prev = updated[index].uploaded_files || [];
        updated[index].uploaded_files = [...prev, uploadedFile];
      }
      updated[index].error_message = "";
      setSectionItem(updated);
    } catch (error) {
      console.error(error);
    } finally {
      if (input?.target) {
        input.target.value = "";
      }
    }
  };

  // Remove file from uploaded_files array
  const removeFile = (fileIndex: number, childKey?: string) => {
  const updated = structuredClone(sectionItem);

  if (childKey) {
    const parent = updated[index];
    const targetChild = findChildByValue(parent, childKey);

    const removedFile = targetChild.uploaded_files?.[fileIndex];

    if (isEdit && !(removedFile instanceof File) && removedFile?.id) {
      setDeletedDocs((prev: any) => [...prev, removedFile?.id]);
    }

    targetChild.uploaded_files =
      targetChild.uploaded_files.filter((_: any, i: number) => i !== fileIndex);
  } else {
    // normal
    const removedFile = updated[index].uploaded_files?.[fileIndex];
    updated[index].uploaded_files =
      updated[index].uploaded_files.filter((_: any, i: number) => i !== fileIndex);

    if (isEdit && !(removedFile instanceof File) && removedFile?.id) {
      setDeletedDocs((prev: any) => [...prev, removedFile?.id]);
    }
  }

  setSectionItem(updated);
};


  const findChildByValue = (node: any, value: string): any => {
  if (node.value === value) return node;
  if (node.child?.length) {
    for (const c of node.child) {
      const found = findChildByValue(c, value);
      if (found) return found;
    }
  }
  return null;
};


const handleRadioChange = (child: any) => {
  setSelectedChild(child);

  const updated = structuredClone(sectionItem);
  const parent = updated[index];

  // ONLY store selected radio
  parent.selected_policy_vehicle = child.value;

  setSectionItem(updated);   // this updates documentFormObj indirectly
  setSelectedChild(child);
};

const getFileMeta = (file: any) => {
  const isFileObj = file instanceof File;
  const rawSrc = isFileObj ? file?.name : (file?.name || file?.src || file?.preview_src);
  const src = isFileObj ? URL.createObjectURL(file) : (file?.preview_src || file?.src);
  const namePart = rawSrc?.split("?")?.[0] || "";
  const ext = namePart?.split(".")?.pop()?.toLowerCase() || "";
  let fileType = ext;
  if (["csv", "xls", "xlsx"].includes(fileType)) fileType = "excel";
  if (fileType === "doc" || fileType === "docx") fileType = "word";
  return { isFileObj, src, fileType };
};



  let showPolicyVehicleCheck = false;
  
  if(selectedChild?.value == DOC_IDS.EXITING_POLICY){
    showPolicyVehicleCheck = document?.child?.find((c: any) => c.value == DOC_IDS.EXITING_POLICY)?.uploaded_files?.length > 0;
  }else{
  const isValid =
      selectedChild?.value === DOC_IDS.VEHICLE &&
      document?.child
        ?.find((c: any) => c.value === DOC_IDS.VEHICLE)
        ?.child
        ?.filter((s: any) => s.is_required === true)
        .every((s: any) => s.uploaded_files?.length > 0);
    showPolicyVehicleCheck = isValid
    
  }


  return (
    <div className="col-md-12 col-xs-12 faq-wrapper resummison-outer document-upload-acc-outer col-md-12 w-100">
      <div className="document-card animation-effect">

        
        <Accordion className="accordian-outer config-accordain">
         <Accordion.Item
            eventKey={String(index)}
            key={index}
            // className={`doc-item ${item.resubmission ? "error" : "ok"}`}
          >

        
        {/* HEADER */}
        <div className="summery-heading upload-heading-text document-upload-id" style={{ background: document.color_code }}>
       
          <Accordion.Header>
              {
          // isMobile &&
          <span className="doc-upload-icn"> <img src={document.logo} /></span> 
         }
          <h3>{document.label} </h3>
          {
            (
              document?.uploaded_files?.length > 0 || 
              (isPolicyVehicleDoc && showPolicyVehicleCheck)
            ) && (
              <div className="check-filed-icn">
                <i className="ic-check"></i>
              </div>
            )
          }
           </Accordion.Header>
        </div>

          <Accordion.Body>

        {/* RADIO FOR POLICY / VEHICLE */}
        {isPolicyVehicleDoc && (
          <div className='form-filed col-md-12 m-xl-b radio-btn existing-loan-fied-radio'>
            <div className="loan-radio-outer d-flex p-sm-t">
              {document.child.map((child: any, idx: number) => (
                <div key={child.value} className="custom-control custom-checkbox col-md-3 col-xs-6">
                  <input
                    type="radio"
                    className="custom-control-input"
                    id={`doc-radio-${child.value}`}
                    name={`doc-radio-${document.value}`}
                    checked={selectedChild?.value === child.value}
                    onChange={() => handleRadioChange(child)}
                  />
                  <label className="custom-control-label" htmlFor={`doc-radio-${child.value}`}> {child.label}</label>
                </div>
              ))}
            </div>
        {document?.error_message ? <span className="error-txt">{document.error_message}</span> : null}
          </div>
        )}

        {/* Normal document upload UI */}
        {!isPolicyVehicleDoc && (
          <div className="row">
            {Array.from({ length: document.max_upload }).map((_, uploadIndex) => {
              const file = files[uploadIndex];

              return (
                <div key={uploadIndex}  className="col-md-2 col-xs-6 p-lg-t p-md-b" >
                  {/* UPLOAD BOX */}
                  {!file && (
                    <div className="add-document-proof"  role="presentation"  >
                      <input
                        type="file"
                        name="documents[]"
                        disabled={files.length >= document.max_upload}
                        onChange={(e) =>
                          handleFileUpload(e)
                        }
                      />
                      <i className="ic-add"></i>
                      <span>Upload</span>

                      {!document.is_required && (
                        <span className="optional-txt">(Optional)</span>
                      )}

                    </div>
                  )}
                  {(document.is_required && document?.error_message) && (
                    <span className="error-txt">{document?.error_message}</span>
                  )}

                  {/*  PREVIEW BOX */}
                  {file && (
                    <div className="upload-image-proof mt-2" id={`upload-image-input-${document.value}-${uploadIndex}`} >
                      <span className="close-icn" onClick={() => removeFile(uploadIndex)}>
                        <i className="ic-clearclose"></i>
                      </span>

                      {(() => {
                        const { src, fileType } = getFileMeta(file);
                        if (fileType === "jpg" || fileType === "jpeg" || fileType === "png") {
                          return <img src={src} alt="" />;
                        }
                        return (
                          <a href={src} target="_blank" rel="noreferrer">
                            <i className={`ic-${fileType}-file f-50`}></i>
                          </a>
                        );
                      })()}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        )}

        {/* Special UI for Policy / Vehicle */}
        {isPolicyVehicleDoc && selectedChild && (
          <div className="row">
            {/* EXISTING POLICY */}
            {selectedChild.label === "Existing Policy" && (
              <SingleUploadBox
                parentIndex={index}
                sectionItem={sectionItem}
                childKey={selectedChild.value}
                setSectionItem={setSectionItem}
                showAddMore={false}
                onUpload={handleFileUpload}
              // photoMeta={photoChild} 
              removeFile= {removeFile}
              />
            )}

            {/* VEHICLE PHOTOS */}
            {selectedChild.label === "Vehicle Photos" &&
              selectedChild.child.map((photoChild: any, photoIndex: number) => (
                <div key={photoChild.value} className="col-md-2 col-xs-6 mb-3">
                  <h5 className="mb-2">{photoChild.label}</h5>

                  <SingleUploadBox
                    parentIndex={index}
                    childKey={photoChild.value}
                    sectionItem={sectionItem}
                    setSectionItem={setSectionItem}
                    photoMeta={photoChild}
                    showAddMore={true}
                    onUpload={handleFileUpload}
                    removeFile = {removeFile}               
                  />
                </div>
              ))}
          </div>
        )}
        

        {/* FORM */}
        <div className="row">
        <DynamicFormFieldId
          fields={fields}
          sectionItem={sectionItem}
          setSectionItem={setSectionItem}
          setLoading={setLoading}
          sectionIndex={CREATE_PAGE_INDEX.DOC}
          requestData={requestData}
          isEdit ={isEdit}
          setRequestData={setRequestData}
        />

      </div>
      </Accordion.Body>
      </Accordion.Item>
      </Accordion>
      </div>
    </div>
  );
};

export default DocumentSection;
